import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么数百万读者选择星星动漫网？</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 transition-all duration-200">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}